import { useAuthListener } from './auth'

export const useBrowserGlobalListener = () => {
  useAuthListener()
}
